import { Expose, Type } from 'class-transformer'

import { Product } from './Product'
import { Sku } from './Sku'

export class PickBySku {
  static type = 'skupick'

  type = PickBySku.type

  @Type(() => Sku)
  sku?: string

  @Type(() => Product)
  product?: string

  @Expose({ name: 'num_units_to_pick' })
  numUnitsToPick?: number
}
